export const introMessage1 = `Congratulations! You've been invited to register for a FREE AmTrav account. Complete this simple registration form and you'll be on your way in no time.`; // eslint-disable-line

export const amtravHome = 'https://www.amtrav.com/';
